var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("JoinHeading", { class: _vm.styleClass.title, attrs: { level: 4 } }, [
        _vm._v("\n    " + _vm._s(_vm.item.title) + "\n  ")
      ]),
      _vm._v(" "),
      _vm._l(_vm.item.paragraphs, function(paragraph) {
        return _c(
          "p",
          {
            key: paragraph,
            class:
              _vm.styleClass.paragraph ||
              _vm.JoinTitleParagraphStyleModule.paragraph
          },
          [_vm._v("\n    " + _vm._s(paragraph) + "\n  ")]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }